import React from 'react';
import classNames from 'classnames';
import SingleBar from './SingleBar';
import styles from './SegmentedProgressBars.module.scss';

export default function SegmentedProgressBars({
  containerClassName,
  barClassName,
  activeBarsCount,
  maxBarsCount,
}) {
  const barsDifference = maxBarsCount - activeBarsCount;
  const classes = classNames(styles.container, containerClassName);
  return (
    <div className={classes}>
      {[...Array(Number(activeBarsCount))].map((_, index) => {
        return <SingleBar key={index} barClassName={barClassName} active />;
      })}
      {[...Array(barsDifference)].map((_, index) => {
        return (
          <SingleBar key={index} barClassName={barClassName} active={false} />
        );
      })}
    </div>
  );
}
